import React, { Component } from "react";
import ReactMarkdown from "react-markdown";
import { NavLink } from "react-router-dom";

import { Link } from "@material-ui/core";

class IABStandard extends Component {
  constructor(props) {
    super(props);

    this.state = { content: null };
  }

  componentWillMount() {
    fetch(process.env.PUBLIC_URL + "/static/markdown/IABStandard.md")
      .then((response) => response.text())
      .then((text) => {
        this.setState({ content: text });
      });
  }

  render() {
    return (
      <div className="content">
        <Link component={NavLink} exact to="/document/center">
          Centro de Documentos
        </Link>
        <ReactMarkdown children={this.state.content} />
      </div>
    );
  }
}

export default IABStandard;
